import { FrameData } from '../../types';
import { hsl } from '../../utils/colorUtils';
import { LayerRenderer } from './LayerRenderer';

interface Ring {
  radius: number;
  alpha: number;
}

export class RingPulseRenderer implements LayerRenderer {
  private rings: Ring[] = [];

  init(): void {}

  render(
    ctx: CanvasRenderingContext2D,
    frame: FrameData,
    settings: Record<string, number>,
    width: number,
    height: number,
  ): void {
    const { isBeat, beatIntensity, deltaTime } = frame;
    const colorHue = settings.colorHue ?? 200;
    const ringWidth = settings.ringWidth ?? 2;
    const expandSpeed = settings.expandSpeed ?? 0.15;
    const threshold = settings.threshold ?? 0.3;
    const cx = width / 2;
    const cy = height / 2;

    // Spawn new ring on beat
    if (isBeat && beatIntensity > threshold) {
      this.rings.push({ radius: 20, alpha: 0.7 * beatIntensity });
    }

    // Update and draw rings
    for (let i = this.rings.length - 1; i >= 0; i--) {
      const ring = this.rings[i];
      ring.radius += deltaTime * expandSpeed;
      ring.alpha -= deltaTime * 0.0008;

      if (ring.alpha <= 0) {
        this.rings.splice(i, 1);
        continue;
      }

      ctx.beginPath();
      ctx.arc(cx, cy, ring.radius, 0, Math.PI * 2);
      ctx.strokeStyle = hsl(colorHue, 70, 60, ring.alpha);
      ctx.lineWidth = ringWidth;
      ctx.stroke();
    }
  }

  resize(): void {}

  destroy(): void {
    this.rings = [];
  }
}
